



























import { Component, Vue, Prop } from 'vue-property-decorator'
import { AddCompany } from '../store/company'

@Component
export default class CompanyForm extends Vue {
  @Prop() title!: string
  @Prop({ default: () => ({}) }) placeholder!: AddCompany
  name = this.placeholder.name || ''
  nameRules = [(v: string) => !!v || 'Name is required']
  valid = false

  submit() {
    this.$emit('submit', { name: this.name })
  }
  cancel() {
    this.$emit('cancel')
  }
}
